import $ from 'jquery';

window.addEventListener('load', function() {

  $('.js-load-more-news').on('click', function(){

    var $top_news = $('.top-news');
    var top_news_id = $top_news.data('id');
    var $news_list = $('#crosslinking-news-list');
    var paged = parseInt($news_list.attr('data-paged'));
    var filter = $news_list.attr('data-filter');
    var maxnumpages = $news_list.attr('data-maxnumpages');

    // Ajax Post
    $.ajax({
      cache: true,
      url: ajaxurl,
      type: 'get',
      data: {
        action: 'load_posts',
        type: 'news',
        top_news_id: top_news_id,
        filter: filter,
        paged: paged + 1,
      },
      success: function( html ) {
        paged = paged + 1;
        $('#crosslinking-news-list').attr("data-paged", paged);
        $news_list.append( html );
        if( paged >= maxnumpages )
          $('.news-more').remove();
      }
    });

  });

});
